import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    'here': {
        id: 'here',
        defaultMessage: 'here',
    },
});

